module.exports = __webpack_public_path__ + "static/media/logo-main.2a6a5678.png";